/**
 * AddProductDialog — dialog for adding a miscellaneous product during inventory counting.
 */
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { PlusCircle, Check } from "@phosphor-icons/react";

export function AddProductDialog({ open, onOpenChange, newProduct, setNewProduct, onSave }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" data-testid="add-product-btn">
          <PlusCircle size={16} className="mr-2" />
          Add Item
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading tracking-wide">ADD MISCELLANEOUS ITEM</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div>
            <Label>Product Name</Label>
            <Input
              data-testid="new-product-name"
              value={newProduct.name}
              onChange={(e) => setNewProduct(p => ({ ...p, name: e.target.value }))}
              placeholder="e.g., Olive Oil"
            />
          </div>
          <div>
            <Label>Unit Definition</Label>
            <Input
              data-testid="new-product-unit"
              value={newProduct.unit}
              onChange={(e) => setNewProduct(p => ({ ...p, unit: e.target.value }))}
              placeholder="e.g., 1 CS = 12 EA"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Examples: "1 CS = 12 EA", "1 CS = 20lb", "1 CS = 5 x 2.2lb"
            </p>
          </div>
          <div>
            <Label>Category (Optional)</Label>
            <Input
              data-testid="new-product-category"
              value={newProduct.category}
              onChange={(e) => setNewProduct(p => ({ ...p, category: e.target.value }))}
              placeholder="e.g., Oils & Vinegars"
            />
          </div>
          <Button onClick={onSave} className="w-full" data-testid="save-new-product-btn">
            <Check size={16} className="mr-2" />
            Add Product
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
